import React, { useState, useEffect } from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import * as styles from "./subscribe.module.scss"
import GrowthChannel from "../../../helpers/growth-channel"
import Effect1Svg from "../../../images/effects/effect1.svg"
import Effect2Svg from "../../../images/effects/effect2.svg"
import Illustration from "../../atoms/illustration"
import Logo from "../../atoms/logo"
import Wrapper from "../../atoms/wrapper"
import FormState from "../../molecules/form-state"
import Nav from "../../molecules/nav"
import SubscribeFirst from "../../molecules/subscribe-first"
import SubscribeSecond from "../../molecules/subscribe-second"
import SubscribeThird from "../../molecules/subsribe-third"

const Subscribe = ({ defaultStep, data, fullscreen }) => {
  const [step, setStep] = useState(defaultStep)
  const [email, setEmail] = useState("")
  const [renderedIllustration, setRenderedIllustration] = useState(
    data.sanitySubscribe.illustration.default?.image
  )
  const [phone, setPhone] = useState(data.sanitySubscribe.phone.default)
  const vertical = data.sanitySubscribe.vertical.slug.current
  let isMounted = false

  const movePhone = (e) => {
    if (isMounted) {
      const xMovement = (e.clientX / document.body.offsetWidth - 0.5) * 20
      const yMovement = (e.clientY / document.body.offsetHeight - 0.5) * 20
      const rotation = (3 * xMovement + 100) / 15
      document.querySelector(`.${styles.phone}`).style.transform =
        `translate(${xMovement}px, ${yMovement}px) rotate(${rotation}deg)`
    }
  }

  useEffect(() => {
    if (sessionStorage.getItem(`subscribed_${vertical.replace("-", "")}`))
      setStep("third")

    isMounted = true
    window.addEventListener("mousemove", movePhone)

    const phoneImg = GrowthChannel(data.sanitySubscribe.phone.growth_channel)
    if (phoneImg) {
      setPhone(phoneImg.phone.path)
    }

    const illustrationCustom = GrowthChannel(
      data.sanitySubscribe.illustration.growth_channel
    )
    if (illustrationCustom) {
      setRenderedIllustration(illustrationCustom.icon?._id)
    }

    return function cleanup() {
      isMounted = false
      window.removeEventListener("mousemove", movePhone)
    }
  }, [])

  useEffect(() => {
    if (step === "third")
      window.history.pushState({}, "", `/subscribe-${vertical}-thank-you`)
  }, [step])

  return (
    <div
      id="subscribe"
      className={`${styles.subscribe} ${styles[`subscribe__${vertical.replace("-", "")}`]} ${styles[`subscribe__${data.sanitySubscribe.vertical.color.replaceAll("-", "")}`]}`}
    >
      <Wrapper
        container
        flex
        className={
          styles[
            `wrapper__${data.sanitySubscribe.vertical.color.replaceAll("-", "")}`
          ]
        }
      >
        <FormState flex condition={step !== "third"}>
          <div className={styles.left}>
            <div className={styles.logo}>
              <Logo light />
            </div>
            <FormState condition={step === "first"}>
              <GoogleReCaptchaProvider
                reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY}
              >
                <SubscribeFirst
                  data={data.sanitySubscribe}
                  changeStep={setStep}
                  changeEmail={setEmail}
                  illustration={renderedIllustration}
                />
              </GoogleReCaptchaProvider>
            </FormState>
            <FormState condition={step === "second"}>
              <SubscribeSecond
                data={data.sanitySubscribe}
                changeStep={setStep}
                email={email}
              />
            </FormState>
          </div>
          <div className={styles.right}>
            <Image {...phone} width={400} className={styles.phone} alt="" />
            <img
              src={Effect1Svg}
              className={`${styles.effect} ${styles.effect__1}`}
              alt=""
            />
            <img
              src={Effect2Svg}
              className={`${styles.effect} ${styles.effect__2}`}
              alt=""
            />
            <Illustration
              size="l"
              className={`${styles.effect} ${styles.effect__illustration}`}
              icon={renderedIllustration}
            />
          </div>
        </FormState>
        <FormState flex condition={step === "third"}>
          <SubscribeThird
            data={data.sanitySubscribe}
            email={email}
            bg={data.sanitySubscribe.vertical.color.replaceAll("-", "")}
          />
        </FormState>
      </Wrapper>
      {fullscreen ? (
        <div className={styles.fullscreenNav}>
          <Nav nav={data.bottomNav.items} type="bottom" />
        </div>
      ) : (
        ""
      )}
    </div>
  )
}

Subscribe.propTypes = {
  data: PropTypes.object.isRequired,
  defaultStep: PropTypes.string,
  fullscreen: PropTypes.bool,
}

Subscribe.defaultProps = {
  defaultStep: "first",
  fullscreen: false,
}

export default Subscribe
